import React from 'react'
import InputBase from '@mui/material/InputBase'
import { isInvalid } from '@carsys/form/src/utils'
import { FieldHookConfig, useField } from 'formik'
import { LicensePlateInputBase } from '@carsys/ui/src/LicensePlate/LicensePlateInputBase'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'

interface LicensePlateInputProps
  extends Omit<React.ComponentProps<typeof InputBase>, 'component' | 'defaultValue' | 'name' | 'value' | 'size'>,
    Pick<FieldHookConfig<string>, 'name' | 'validate'>,
    Pick<React.ComponentProps<typeof LicensePlateInputBase>, 'size' | 'country' | 'required'> {}

const LicensePlateInputFormikField: React.FC<LicensePlateInputProps> = ({ country, size, required, name, validate, ...rest }) => {
  const [input, meta, helpers] = useField<string>({ name, validate })

  useRegisterFormField(name)

  return (
    <LicensePlateInputBase country={country} size={size} required={required} value={input.value} disabled={rest.disabled}>
      {(classes, rows, maskedValue) => (
        <InputBase
          fullWidth
          minRows={rows}
          maxRows={rows}
          multiline={rows > 1}
          id={input.name}
          required={required}
          error={isInvalid(meta)}
          className={classes.input}
          data-testid='license-plate-input'
          {...rest}
          {...input}
          value={maskedValue}
          inputProps={{
            maxLength: 12,
            autoComplete: 'off'
          }}
          onChange={event => {
            helpers.setValue(event.target.value.toLocaleUpperCase().replace('\u000A', '-'))
          }}
        />
      )}
    </LicensePlateInputBase>
  )
}

export default LicensePlateInputFormikField
